import React from "react";
import Footer from "../components/Footer";
import Gallary from "../components/Gallary";
import Navbar from "../components/Navbar";
import Title from "../components/Title";

function Projects() {
  const navigation = [
    { name: "Home", href: "/", current: false },
    // { name: "About", href: "/about", current: false },
    { name: "Projects", href: "/projects", current: true },
    // { name: "Work/Research", href: "/experience", current: false },
    // {name: "Awards", href: "/awards", current: false},
    // { name: "Featured", href: "/featured", current: false },
  ];
  return (
    <div className="lg:grid lg:h-fit lg:place-items-center">
      <div className="lg:w-3/4 bg-customGray outline-outlineGray outline">
        <Navbar navigation={navigation} />
        <Title
          heading="My Projects"
          body="Click to see more info :)"
        />
        <Gallary />
        <Footer />
      </div>
    </div>
  );
}

export default Projects;
